import { render, staticRenderFns } from "./MessageHandler.vue?vue&type=template&id=e6e761f2&scoped=true&"
import script from "./MessageHandler.vue?vue&type=script&lang=js&"
export * from "./MessageHandler.vue?vue&type=script&lang=js&"
import style0 from "./MessageHandler.vue?vue&type=style&index=0&id=e6e761f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e761f2",
  null
  
)

export default component.exports